import Link from 'next/link'
import { ArrowLeftIcon, ArrowRightIcon } from '@heroicons/react/solid'
import { useState } from 'react'
import { Tooltip } from '@components/UI/Tooltip'

export function DomoreportWalkthrough(props) {
  const [step, setStep] = useState(1)

  return (
    <div className="flex flex-col items-center justify-evenly">
      <div className="md:flex hidden space-x-8 mb-16">
        <button
          className={`hover:bg-gold-400 p-4 font-black folded-r-1 transition cursor-pointer ${
            step === 1
              ? 'bg-gold-400 text-black'
              : 'bg-transparent text-gray-700'
          }`}
          onClick={e => setStep(1)}
        >
          1. Upload Home Inspection
        </button>

        <button
          className={`hover:bg-gold-400 p-4 font-black folded-r-1 transition cursor-pointer ${
            step === 2
              ? 'bg-gold-400 text-black'
              : 'bg-transparent text-gray-700'
          }`}
          onClick={e => setStep(2)}
        >
          2. Get Domoreport
        </button>

        <button
          className={`hover:bg-gold-400 p-4 font-black folded-r-1 transition cursor-pointer ${
            step === 3
              ? 'bg-gold-400 text-black'
              : 'bg-transparent text-gray-700'
          }`}
          onClick={e => setStep(3)}
        >
          3. Review Domoreport
        </button>

        <button
          className={`hover:bg-gold-400 p-4 font-black folded-r-1 transition cursor-pointer ${
            step === 4
              ? 'bg-gold-400 text-black'
              : 'bg-transparent text-gray-700'
          }`}
          onClick={e => setStep(4)}
        >
          4. Build Request List
        </button>
      </div>

      {step === 1 && (
        <div className="flex md:flex-row flex-col">
          <div className="flex items-end md:justify-end justify-center md:w-1/2 w-full">
            <img
              src="/images/product-pages/Step1.svg"
              className="md:max-w-sm md:w-auto w-48"
            />
          </div>

          <div className="flex flex-col justify-center max-w-sm md:w-1/2 w-full md:space-y-16 space-y-4 md:pl-4">
            <p className="font-bold">1. Upload Home Inspection</p>

            <div className="space-y-4">
              <h4 className="font-black text-2xl">
                Simply upload a PDF of your home inspection.
              </h4>
              <p>
                Rest easy while Majordomo experts analyze your inspection and
                prepare your Domoreport.
              </p>
            </div>

            <Link href="/checkout">
              <a className="flex items-center font-black text-accentBlue hover:underline">
                <ArrowRightIcon
                  width={20}
                  height={20}
                  className="mr-2 text-gold-400"
                />{' '}
                Get started and upload the home inspection
              </a>
            </Link>

            <div className="flex items-center">
              <button className="flex items-center justify-center p-2">
                <ArrowLeftIcon
                  width={20}
                  height={20}
                  className="text-gray-200"
                />
              </button>

              <Tooltip label="Next Step">
                <button
                  className="flex p-2 cursor-pointer"
                  onClick={e => {
                    setStep(2)
                  }}
                >
                  <ArrowRightIcon
                    width={20}
                    height={20}
                    className="text-black"
                  />
                </button>
              </Tooltip>
            </div>
          </div>
        </div>
      )}

      {step === 2 && (
        <div className="flex md:flex-row flex-col">
          <div className="flex items-end md:justify-end justify-center md:w-1/2 w-full">
            <img
              src="/images/product-pages/Step2.svg"
              className="md:max-w-sm md:w-auto w-48"
            />
          </div>

          <div className="flex flex-col justify-center max-w-sm md:w-1/2 w-full md:space-y-16 space-y-4 md:pl-4">
            <p className="font-bold">2. Get Domoreport within 24 hours</p>

            <div className="space-y-4">
              <h4 className="font-black text-2xl">
                Receive an email and text alert when the Domoreport is ready.
              </h4>
              <p>
                Instantly see estimated repair costs and projects; start working
                with buyer on the next steps.
              </p>
            </div>

            <Link href="/checkout">
              <a className="flex items-center font-black text-accentBlue hover:underline">
                <ArrowRightIcon
                  width={20}
                  height={20}
                  className="mr-2 text-gold-400"
                />{' '}
                Get started and upload the home inspection
              </a>
            </Link>

            <div className="flex items-center cursor-pointer">
              <Tooltip label="Previous Step">
                <button
                  className="flex items-center justify-center p-2"
                  onClick={e => {
                    setStep(1)
                  }}
                >
                  <ArrowLeftIcon width={20} height={20} />
                </button>
              </Tooltip>

              <Tooltip label="Next Step">
                <button
                  className="flex p-2 cursor-pointer"
                  onClick={e => {
                    setStep(3)
                  }}
                >
                  <ArrowRightIcon
                    width={20}
                    height={20}
                    className="text-black"
                  />
                </button>
              </Tooltip>
            </div>
          </div>
        </div>
      )}

      {step === 3 && (
        <div className="flex md:flex-row flex-col">
          <div className="flex items-end md:justify-end justify-center md:w-1/2 w-full">
            <img
              src="/images/product-pages/Step3.svg"
              className="md:max-w-sm md:w-auto w-48"
            />
          </div>

          <div className="flex flex-col justify-center max-w-sm md:w-1/2 w-full md:space-y-16 space-y-4 md:pl-4">
            <p className="font-bold">3. Review Domoreport</p>

            <div className="space-y-4">
              <h4 className="font-black text-2xl">
                Dive into the repair details.
              </h4>
              <p>
                Get a cost breakdown of each estimate: quantity, quality,
                material, labor, equipment, and fees. These details will improve
                your chances of a successful negotiation.
              </p>
            </div>

            <Link href="/checkout">
              <a className="flex items-center font-black text-accentBlue hover:underline">
                <ArrowRightIcon
                  width={20}
                  height={20}
                  className="mr-2 text-gold-400"
                />{' '}
                Get started and upload the home inspection
              </a>
            </Link>

            <div className="flex items-center cursor-pointer">
              <Tooltip label="Previous Step">
                <button
                  className="flex items-center justify-center p-2"
                  onClick={e => {
                    setStep(2)
                  }}
                >
                  <ArrowLeftIcon width={20} height={20} />
                </button>
              </Tooltip>

              <Tooltip label="Next Step">
                <button
                  className="flex p-2 cursor-pointer"
                  onClick={e => {
                    setStep(4)
                  }}
                >
                  <ArrowRightIcon
                    width={20}
                    height={20}
                    className="text-black"
                  />
                </button>
              </Tooltip>
            </div>
          </div>
        </div>
      )}

      {step === 4 && (
        <div className="flex md:flex-row flex-col">
          <div className="flex items-end md:justify-end justify-center md:w-1/2 w-full">
            <img
              src="/images/product-pages/Step4.svg"
              className="md:max-w-sm md:w-auto w-48"
            />
          </div>

          <div className="flex flex-col justify-center max-w-sm md:w-1/2 w-full md:space-y-16 space-y-4 md:pl-4">
            <p className="font-bold">4. Review Domoreport</p>

            <div className="space-y-4">
              <h4 className="font-black text-2xl">
                Build a custom request list with built-in tools and start
                negotiations with confidence
              </h4>
              <p>
                Include the requests you want to ask the seller to repair, or
                receive credit. Print off a professional addendum attachment
                with detailed cost estimates and repair details to validate your
                request.
              </p>
            </div>

            <Link href="/checkout">
              <a className="flex items-center font-black text-accentBlue hover:underline">
                <ArrowRightIcon
                  width={20}
                  height={20}
                  className="mr-2 text-gold-400"
                />{' '}
                Get started and upload the home inspection
              </a>
            </Link>

            <div className="flex items-center cursor-pointer">
              <Tooltip label="Previous Step">
                <button
                  className="flex items-center justify-center p-2"
                  onClick={e => {
                    setStep(3)
                  }}
                >
                  <ArrowLeftIcon width={20} height={20} />
                </button>
              </Tooltip>

              <button className="flex p-2">
                <ArrowRightIcon
                  width={20}
                  height={20}
                  className="text-gray-200"
                />
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
